import { CheckboxFilter } from "./UnionAuditReportData";

const ReportDispatchTypes = {
  1: 'DAY',
  3: 'NIGHT',
  5: 'GRAVEYARD',
  67: '5:45 - COASTWISE',
  68: '5:45 - SQUAMISH'
}

export const REPORT_DISPATCH_TYPES = Object.entries(ReportDispatchTypes).map(
  ([key, value]) => ({ code: key, display: value })
);

export const CheckboxFilters: CheckboxFilter[] = [
  { key: 1, label: 'Used the DOA and dispatched' },
  { key: 2, label: 'Did not use the DOA and dispatched' },
  { key: 3, label: 'Used the DOA and not dispatched' },
  { key: 5, label: 'Was eligible to work' }
];
